import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function CreateWorkOrderViewModel(logout, userId, userName) {
  const [customers, setCustomers] = useState([]);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getCustomersForDropdown = async function () {
    let callResult = await makeGetApiCall(`customersForDropdown`);
    if (callResult.success) {
      setCustomers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const createWorkOrderApiCall = async function (newOrder) {
    let callResult = await makePostApiCall(
      `workOrders/create`,
      {
        ...newOrder,
        employee: { value: userId, label: userName },
        check_heat_exchanger: newOrder.check_heat_exchanger ? 1 : 0,
        check_burners: newOrder.check_burners ? 1 : 0,
        check_pilot_assembly: newOrder.check_pilot_assembly ? 1 : 0,
        check_venting: newOrder.check_venting ? 1 : 0,
        check_high_limit_and_fan_control:
          newOrder.check_high_limit_and_fan_control ? 1 : 0,
        check_temperature_rise: newOrder.check_temperature_rise ? 1 : 0,
        check_carbon_monoxide_in_flue_products:
          newOrder.check_carbon_monoxide_in_flue_products ? 1 : 0,
        check_combustion_and_ventilation_air_supply:
          newOrder.check_combustion_and_ventilation_air_supply ? 1 : 0,
        check_compressor_and_fan_contactors:
          newOrder.check_compressor_and_fan_contactors ? 1 : 0,
        check_refrigerant_charge: newOrder.check_refrigerant_charge ? 1 : 0,
        check_safety_controls_set_points_and_functions:
          newOrder.check_safety_controls_set_points_and_functions ? 1 : 0,
        check_condition_of_evaporator_and_condenser_coils:
          newOrder.check_condition_of_evaporator_and_condenser_coils ? 1 : 0,
        check_condensate_drain_trap_and_pan:
          newOrder.check_condensate_drain_trap_and_pan ? 1 : 0,
        check_circulating_air_blower: newOrder.check_circulating_air_blower
          ? 1
          : 0,
        check_belts_and_pulleys: newOrder.check_belts_and_pulleys ? 1 : 0,
        check_motor_amperages: newOrder.check_motor_amperages ? 1 : 0,
        check_thermostats: newOrder.check_thermostats ? 1 : 0,
        check_filter: newOrder.check_filter ? 1 : 0,
        check_all_access_panels_to_be_secure:
          newOrder.check_all_access_panels_to_be_secure ? 1 : 0,
        check_all_electrical_connections:
          newOrder.check_all_electrical_connections ? 1 : 0,
        check_disconnects: newOrder.check_disconnects ? 1 : 0,
        check_gas_piping: newOrder.check_gas_piping ? 1 : 0,
        check_exhaust_fan: newOrder.check_exhaust_fan ? 1 : 0,
      },
      "multipart/form-data"
    );
    if (callResult.success) {
      window.location = `/work-orders/${callResult.data.id}`;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  return {
    customers,
    getCustomersForDropdown,
    setEmptyModelOpen,
    emptyModal,
    showErrorModal,
    createWorkOrderApiCall,
  };
}
